// extracted by mini-css-extract-plugin
module.exports = {"sub-categories":"EncyclopediaCategory_sub-categories__38DCT","categories-grid":"EncyclopediaCategory_categories-grid___EXrW","articles":"EncyclopediaCategory_articles__A_Bsb"};